module.exports = __webpack_public_path__ + "bab94832fe06d81cafb6510df106d0eb.MP3";